import * as utils from '../util';
import { UrlRoyalService } from '../modules/core/services/url-royal.service';
import { UrlCelebrityService } from '../modules/core/services/url-celebrity.service';
import { constants } from '../constants/constants';
import { BRAND } from '~environments/environment';

export function UrlServiceFactory() {
	const brand = BRAND;
	const cookieValue = utils.getDecodedAccessToken(constants.COOKIES.OLCI.OLCI_DATA);
	const wul = cookieValue && cookieValue.locale ? cookieValue.locale : (constants.LANGUAGES.ENGLISH).toLowerCase();

	switch (brand) {
		case constants.BRANDS_NAMES.ROYAL:
			return new UrlRoyalService(constants.APP_STORE_URL.ROYAL, wul);

		case constants.BRANDS_NAMES.CELEBRITY:
			return new UrlCelebrityService(constants.APP_STORE_URL.CELEBRITY, wul);
	}
}
